import { fetchApi } from '@vend/utilities'
import { RetailerDetails } from '../../models/invoicing-payment-request'

/**
 *  Triggers Invoicing account verification and creation if needed [via Vend Invoicing microservice]
 */
export const validateMerchantAccount = async (
  retailerDetails: RetailerDetails
): Promise<void> => {
  const response = await fetchApi(
    '/api/2.0/invoicing/v2/provision/merchant-account',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(retailerDetails),
    }
  )

  if (!response.ok) {
    throw new Error(
      `Failed to validate merchant account within invoicing microservice: ${response.statusText}`
    )
  }
}
